"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useRefMounted_1 = require("./useRefMounted");

var useAsyncFn = function useAsyncFn(fn, deps) {
  if (deps === void 0) {
    deps = [];
  }

  var _a = react_1.useState({
    loading: false
  }),
      state = _a[0],
      set = _a[1];

  var mounted = useRefMounted_1.default();
  var callback = react_1.useCallback(function () {
    set({
      loading: true
    });
    fn().then(function (value) {
      if (mounted.current) {
        set({
          value: value,
          loading: false
        });
      }
    }, function (error) {
      if (mounted.current) {
        set({
          error: error,
          loading: false
        });
      }
    });
  }, deps);
  return [state, callback];
};

exports.default = useAsyncFn;